import type { AppEnvironment } from './environment.model';

export const environment = {
  production: false,
  useHashRouting: false,
  appName: "Bhuvana's Love and Beyond",
  SHOPIFY_STORE_DOMAIN: 'c9a2cd-24.myshopify.com',
  SHOPIFY_STOREFRONT_TOKEN: 'e924afb42219ccb9f8d6c1c2c5204c82',
  SHOPIFY_API_VERSION: '2025-01',
  shopify: {
    storeDomain: 'c9a2cd-24.myshopify.com',
    storefrontAccessToken: 'e924afb42219ccb9f8d6c1c2c5204c82',
    apiVersion: '2025-01',
  },
  seo: {
    siteUrl: 'http://localhost:4200',
    defaultTitle: "Bhuvana's Love and Beyond | Holistic Wellness & Sacred Commerce",
    defaultDescription:
      'Discover curated wellness products, healing sessions, and soulful stories at Bhuvana\'s Love and Beyond.',
    defaultImage: '/images/og-default.jpg',
    twitterHandle: '@bhuvanaslove',
    locale: 'en_US',
  },
  contact: {
    email: 'hello@bhuvanasloveandbeyond.com',
    phone: '+1 (555) 123-4567',
  },
  forms: {
    apiBaseUrl: 'http://localhost:8055',
    apiKey: 'dev-blb-forms-key-local',
  },
} as const satisfies AppEnvironment;
